import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Component, OnInit, ChangeDetectorRef, NgModule } from '@angular/core';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { NavigationService } from '../navigation/navigation.service';
import { Page, Settings } from '../navigation/pages.model';
import { environment } from './../../../environments/environment';
import { SharedModule } from '../shared.module';
import { AuthService, UserState } from '../auth/auth.service';

@Component({
  selector: 'app-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.scss']
})

export class FooterComponent implements OnInit {

  public isMobile = true;
  public allowed = [1,2];
  public navigation: Page[] = [];
  public navigationShop: Page[] = [];
  public mobilePath = [];
  public payments: any[] = [];
  public carriers: any[] = [];
  public settings: Settings = new Settings;
  public pageName = environment.name;
  public cdn = environment.cdn;

  public path_account = 'konto';
  public path_login = 'zaloguj';
  public path_orders = 'konto/zamowienia';
  public path_invoices = 'konto/faktury';

  constructor(private router: Router, private navigationService: NavigationService, private auth: AuthService, private breakpointObserver: BreakpointObserver, private cdr: ChangeDetectorRef) {
    this.breakpointObserver
    .observe(['(min-width: 960px)'])
    .subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isMobile = false;
        this.cdr.markForCheck();
        // Viewport is 500px or over!
      } else {
        this.isMobile = true;
        this.cdr.markForCheck();
        // Viewport is getting smaller!
      }
    });


  }

  ngOnInit() {
    this.navigationService.navigation.subscribe(this.pageChanged);

    this.auth.isLoggedIn.subscribe((state: UserState) => {
      if (state.logged) {
        this.allowed = [1,2];
        this.path_account = this.router.config.find(x => x.data?.id === -991)?.path || '/';
        this.path_login = this.router.config.find(x => x.data?.id === -980)?.path || '/';
        this.path_orders = this.router.config.find(x => x.data?.id === -993)?.path || '/';
        this.path_invoices = this.router.config.find(x => x.data?.id === -1002)?.path || '/';
      } else {
        this.allowed = [1];
        this.path_account = this.router.config.find(x => x.data?.id === -980)?.path || '/';
        this.path_login = this.router.config.find(x => x.data?.id === -980)?.path || '/';
        this.path_orders = this.router.config.find(x => x.data?.id === -980)?.path || '/';
        this.path_invoices = this.router.config.find(x => x.data?.id === -980)?.path || '/';
      }
    });
  }


  toggleChildren(id: number) {
    if (this.mobilePath.includes(id)) {
      this.mobilePath = this.mobilePath.filter((x: number) => x !== id);
    } else {
      this.mobilePath.push(id);
    }
  }

  pageChanged = (setup: any) => {
    this.navigation = setup.footer;
    this.navigationShop = [...setup.menu.find(p => p.module == './offer/offer.module#OfferModule' && +p.visible == 1 && p.children.length)?.children || []];
    let toplvl = setup.menu.find(p => p.module == './offer/offer.module#OfferModule' && +p.visible == 1 && p.children.length == 0);
    if (toplvl) this.navigationShop.unshift(toplvl);
    this.payments = setup.payments;
    this.carriers = setup.carriers;
    this.settings = setup.settings;
    this.cdr.detectChanges();
  }
}

@NgModule({
  declarations: [FooterComponent],
  imports: [CommonModule, SharedModule]
})
class FooterModule { }
